import { createRenderer } from "@vue/runtime-core";
import { nodeOps } from "./nodeOps";
import { patchProp } from "./patchProp";
export function createRendererForStage(stage) {
    const { render } = createRenderer(Object.assign({ patchProp }, nodeOps(stage)));
    return render;
}
export * from "./nodes";
//# sourceMappingURL=index.js.map